import { InjectionToken }    from '@angular/core';
import { DeploymentDetails } from '@cs/common/classes/pm-deploy-info.models';
import { Environment }       from '@cs/common/services';

export interface DeploymentConfig {
	/**
		* Use the mocking framework
		*/
	useMockData: boolean;
	/**
		* Current running environment.
		*/
	environment: Environment;
	/**
		* API Key for GoogleMaps
		*/
	googleMapsApiKey?: string;
	/**
		* info about the deployment, used to set the environment details label
		*/
	deploymentDetails: DeploymentDetails;
	/**
		* Set the location for the the transaction files
		*/
	translationLocation: string;

	/**
		* Set relative root of the api from the domain.top. like '/api-endpoint-root'
		*/
	apiEndpoint: string;
}

export interface CustomerAppConfig {

	/**
		* The title shown in browser tab
		*/
	title: string;

	/**
		* Enter the support email shown on login page
		*/
	supportEmail: string;

	/**
		* Name of the customer
		*/
	customerName: string;
}


export const CUSTOMER_VARS_TOKEN = new InjectionToken<string>('CUSTOMER_VARS_TOKEN');





